import { Provider } from 'react-redux';
import { store } from '../../state';
import Wrapper from "../../components/Wrapper";
import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { STK_API } from '../../components/constants';
import { useUserContext } from '../../components/UserContext';
 

interface TopupsProps{
  msisdn: string; // Define the msisdn prop type
  bal:number,
  minBal:number,
}

const Topups:React.FC<TopupsProps> = ({ msisdn, bal, minBal }) => {
  // Utilize the msisdn prop
  useEffect(() => {
    //console.log('msisdn in Races:', msisdn);
    // You can perform actions based on the msisdn value here
  }, [msisdn]); // Add msisdn to the dependency array if used in useEffect

  const[amount,setAmount] = useState("");
  const[redirect, setRedirect] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showFail, setShowFail] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const[responseDesc, setResponseDesc] = useState("");
  const[showTopupMessage, setShowTopupMessage] = useState(false);
  const {defaultMinBal, defaultBal, setDefaultBal } = useUserContext();
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  var msg = searchParams.get('msg');
  useEffect(() => {
    if (msg === "1") {
      setShowTopupMessage(true);
    }
  }, [msg]);
  const submit = async (e: React.SyntheticEvent) => {
  e.preventDefault();
  setLoading(true);
  try {
    const { data } = await axios.post(`${STK_API}`, {
      "TransactionDesc": "Race",
      "PhoneNumber": msisdn?.toString() || "", // handle potential undefined values
      "CallBackURL": "",
      "Amount": amount?.toString() || "", // handle potential undefined values
      "AccountReference": "topup"
    });
 
    if(data.ResponseCode === "0") {
      setLoading(false);
      setShowSuccess(true);
      setResponseDesc(data.ResponseDescription); 
      // Hide the success message after a certain period
      setTimeout(() => {
        setShowSuccess(false);
      }, 3000); // Adjust the duration as needed

      setTimeout(() => {
        setRedirect(true);
      }, 3000); 

    }else{
      setLoading(false);
      setShowFail(true);
      setErrorMessage(data.errorMessage); 
      // Hide the success message after a certain period
      setTimeout(() => {
        setShowFail(false);
      }, 3000); // Adjust the duration as needed

      setTimeout(() => {
        setRedirect(true);
      }, 3000); 
    }

      //console.log(data);
   
  } catch (error) {
      //console.error('Topup request Failed:', error);
      setShowFail(true);
      setErrorMessage("Failed to connect. Kindly check your connection"); 
      setLoading(false);
  }
};

if (redirect) {
  return <Navigate to={'/race'}  />;
}

    return (<>
      <Wrapper msisdn={msisdn}>
        <Provider store={store}>
          <form onSubmit={submit}>
            <div className="container bg-blue-400 h-screen opacity-70 place-items-center">
              <div className='flex items-center justify-center h-screen bg-black rounded-md shadow-md m-2'>
                <div className="flex flex-col items-center">

                {showTopupMessage && (
            <div className="bg-grey-500 text-white p-4 absolute top-0 justify-center mt-10 mr-10 ">
              Kindly topup to begin your RACE!
            </div>
          )}
                  {/* Div showing default balance */}
                  <div className="bg-gray-800 text-white p-2 rounded-md mb-4">
                    {/* Your content */}
                    Bal: <span className='text-5xl'>{defaultBal}</span><p/>
                    Available: {defaultMinBal} <p/>
                  </div>
    
                  {/* Div with input */}
                  <div className="mx-8 bg-white p-4 rounded-lg shadow-md flex flex-col sm:flex-row items-center justify-center gap-y-2">
                    <input
                      type="number"
                      className="border font-extrabold border-gray-300 rounded-md px-3 py-2 mr-2 focus:outline-none"
                      placeholder="Amount"
                      onChange={(e) => setAmount(e.target.value)}
                      required
                    />
                    <button className="bg-blue-500 font-extrabold hover:bg-blue-600 text-white py-2 px-4 rounded-md shadow-md transition duration-300">
                      Topup
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
          {showSuccess && (
            <div className="bg-green-500 text-white p-4 absolute top-0 justify-center mt-10 mr-10 rounded">
              {responseDesc}
            </div>
          )}
    
          {showFail && (
            <div className="bg-red-500 text-white p-4 absolute top-0 mt-10 mr-10 rounded justify-center">
              {errorMessage}
            </div>
          )}
          {/* Spinner */}
      {loading && (
        <div className="flex justify-center items-center fixed top-0 left-0 w-full h-full bg-gray-600 bg-opacity-75 z-50">
          <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-gray-900"></div>
        </div>
      )}
        </Provider>
      </Wrapper>
    </>
    );
};

export default Topups;